import { injectGlobal } from 'react-emotion';

export default (theme) => {
  injectGlobal({
    body: {
      margin: 0,
      padding: 0,
      overflow: 'hidden',
    	backgroundImage: `url(${theme.app.backgroundImage})`,
    	backgroundRepeat: 'repeat-x',
    	backgroundColor: theme.app.backgroundColor,
    },
    a: {
      color: theme.link,
    },
    '#root': {
      overflow: 'hidden',
      margin: 0,
      padding: 0,
    }
  });
};



// WEBPACK FOOTER //
// ./src/global-styles.js